import { useParamsSearch } from '@anytag/shared-hooks';
import { ProposeInfluencersSearchSchemaType, ProposeInfluencersTableMode } from '../schemaTypes';

export const useProposedInfluencersSearch = () => {
  const paramsSearch = useParamsSearch<ProposeInfluencersSearchSchemaType>();

  const { tableViewMode } = paramsSearch.filter;

  return {
    ...paramsSearch,
    isViewMode: tableViewMode === ProposeInfluencersTableMode.VIEW,
    isEditMode: tableViewMode === ProposeInfluencersTableMode.EDIT
  };
};
